import { useState } from "react";
import "./WinnerModal.css";

export default function WinnerModal({ isOpen, onClose, text }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                {/* Nút đóng */}
                <button className="modal-close" onClick={onClose}>✖</button>

                {/* Tiêu đề */}
                <h2 className="modal-title">🎉 Chúc Mừng Trúng Thưởng! 🎉</h2>

                {/* Danh sách người thắng */}
                <div className="modal-winner-content">

                    <p  className="winner-item">
                        {text}
                    </p>

                </div>

                {/* Nút Đóng */}
                <button className="modal-button" onClick={onClose}>Đóng</button>
            </div>
        </div>
    );
}
